/* Audit activity — mirrors the design's `.tbl`, `.fchip`, `.alert`, `.empty`
   classes from .design-ref/pim-admin/index.html (1:1 px / colors). */

/* filter chips: DS Chip (active) inside a bare toggle button */
.chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 16px 20px 0;
  margin-bottom: 16px;
}

.chipBtn {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

.when {
  font-size: var(--font-size-m);
  color: var(--color-grey);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.actor {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actorName {
  font-size: var(--font-size-m);
  font-weight: 400;
}

.action {
  font-size: var(--font-size-m);
}

.target {
  font-size: var(--font-size-m);
  color: var(--color-grey);
}

/* empty state (design .empty) */
.empty {
  text-align: center;
  padding: 50px 24px;
}

.emptyBubble {
  width: 56px;
  height: 56px;
  border-radius: var(--border-radius-l);
  background: var(--color-primary-lightest);
  color: var(--color-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.emptyTitle {
  font-size: var(--font-size-xl);
  font-weight: 400;
}

.emptySub {
  font-size: var(--font-size-m);
  color: var(--color-grey);
  margin: 8px auto 0;
  max-width: 420px;
  line-height: 1.5;
}

/* per-user compact variant (no table chrome) */
.stack {
  display: flex;
  flex-direction: column;
}

.gatedNote {
  font-size: var(--font-size-m);
  color: var(--color-grey);
}

/* same note, padded for the flush feed card */
.gatedNoteFeed {
  display: block;
  padding: 20px;
  font-size: var(--font-size-m);
  color: var(--color-grey);
}

/* per-person activity: day groups of status rows */
.day {
  display: flex;
  flex-direction: column;
}

.dayLabel {
  margin: var(--spacing-3) 0 var(--spacing-1);
  font-size: var(--font-size-s);
  font-weight: inherit;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-grey-light);
}

.row {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-3);
  padding: 9px 0;
}

.row:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-lightest);
}

.ic {
  width: 24px;
  height: 24px;
  border-radius: var(--border-radius-m);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icOk {
  background: var(--color-success-lightest);
  color: var(--color-success);
}

.icErr {
  background: var(--color-error-lightest);
  color: var(--color-error);
}

.main {
  flex: 1;
  min-width: 0;
}

.labelLine {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-wrap: wrap;
}

.label {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.detail {
  display: block;
  font-size: var(--font-size-s);
  color: var(--color-grey-dark);
  margin-top: 2px;
}

.meta {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 2px;
}

.more {
  display: flex;
  justify-content: center;
  padding-top: var(--spacing-3);
}

.actionCell {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--spacing-2);
}
